import * as React from "react";
import PriceCheckIcon from "@mui/icons-material/PriceCheck";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import BarChartIcon from "@mui/icons-material/BarChart";
import PurchaseIcon from "@mui/icons-material/OilBarrel";
import { Colors } from "@/theme";

export const drawerItems = (path) => {
  const paths = [
    "/main/dashboard",
    "/main/price-monitor",
    "/main/manage-price",
    "/main/purchase-stock",
  ];
  return [
    {
      id: "dashboard",
      icon: (
        <BarChartIcon
          sx={{
            fontSize: 35,
            color: path.includes(paths[0]) ? Colors.GREEN : Colors.GRAY_LIGHT,
          }}
        />
      ),
      redirectTo: paths[0],
      selected: path.includes(paths[0]),
    },
    {
      id: "price-monitor",
      icon: (
        <PriceCheckIcon
          sx={{
            fontSize: 40,
            color: path.includes(paths[1]) ? Colors.GREEN : Colors.GRAY_LIGHT,
          }}
        />
      ),
      redirectTo: paths[1],
      selected: path.includes(paths[1]),
    },
    {
      id: "manage-price",
      icon: (
        <LocalOfferIcon
          sx={{
            fontSize: 35,
            color: path.includes(paths[2]) ? Colors.GREEN : Colors.GRAY_LIGHT,
          }}
        />
      ),
      redirectTo: paths[2],
      selected: path.includes(paths[2]),
    },
    {
      id: "purchase-stock",
      icon: (
        <PurchaseIcon
          sx={{
            fontSize: 35,
            color: path.includes(paths[3]) ? Colors.GREEN : Colors.GRAY_LIGHT,
          }}
        />
      ),
      redirectTo: paths[3],
      selected: path.includes(paths[3]),
    },
  ];
};
